/**
 * @description
 * @author librajt
 */

import Api from '../../path';
import { fetchData, fetchDataSync } from '@umu/umu-fetch';

interface IInput {
    element_id: number;
    weike_status?: number; // 0 1 非直播，2 为直播
    page?: number;
    size?: number;
}

export const getElementListening = (data: IInput): Promise<IListResponse<IUserBaseInfo>> => {
    return fetchData(Api.GET_ELEMENT_LISTENING, data).then((res: IListResponse<IUserBaseInfo>) => {
        return res;
    });
};

export const getElementListeningSync = fetchDataSync(getElementListening);
